import React from 'react';
import { IoIosAddCircleOutline, IoIosClose } from 'react-icons/io';

const RocksTargetCompOne = ({ title, data, onAddRow, onDeleteRow, onChange, isEditing }) => {
    return (
        <div className="box-title">
            <h4 className="m-2">
                {title}:
                {isEditing && (
                    <IoIosAddCircleOutline
                        onClick={onAddRow}
                        style={{
                            fontSize: '20px',
                            cursor: 'pointer',
                            verticalAlign: 'middle',
                        }}
                    />
                )}
            </h4>

            <table className="table table-borderless mt-2">
                <tbody>
                    {data.map((row, index) => (
                        <tr key={index}>
                            <td className="text-grey rocksnargetswidth p-2">
                                {isEditing ? (
                                    <>
                                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px' }}>
                                            Description
                                        </label>
                                        <input
                                            type="text"
                                            value={row.description}
                                            onChange={(e) => onChange(e, 'description', index)}
                                            className='effect-1'
                                        />
                                    </>
                                ) : (
                                    row.description
                                )}
                            </td>
                            <td className="text-grey rocksnargetswidth p-2">
                                {isEditing ? (
                                    <>
                                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px' }}>
                                            Value
                                        </label>
                                        <input
                                            type="text"
                                            value={row.value}
                                            onChange={(e) => onChange(e, 'value', index)}
                                            className='effect-1'
                                        />
                                    </>
                                ) : (
                                    row.value
                                )}
                            </td>
                            {isEditing && (
                                <td>
                                    <IoIosClose
                                        onClick={() => onDeleteRow(index)} // Ensure this is correct
                                        style={{
                                            fontSize: '30px',
                                            cursor: 'pointer',
                                            color: 'red',
                                        }}
                                    />
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default RocksTargetCompOne;